import { isEmpty } from 'lodash-es';
import { ROW_FILTER_MISSING } from 'src/components/common/FilterPill/FilterPillList.constants';

import { ListingWithValidPurchaseQuantities } from '../Sections/ManualPricingSection.utils';

export const filterListingItemsBySectionRow = (
  listing: ListingWithValidPurchaseQuantities,
  listingSectionId: number | null,
  sectionIdFilters: number[],
  rowIdFilters: number[],
  sectionRowIdFilters: { [key: string]: string },
  quantityFilter?: number,
  useQuantitiesFilter = false,
  quantitiesFilter?: number[]
) => {
  const sectionId = listingSectionId ?? 0;
  const rowId = listing.seating.rowId ?? 0;
  const quantity = listing.availQty ?? 0;

  // filter by quantity
  if (useQuantitiesFilter) {
    if (
      quantitiesFilter &&
      !isEmpty(quantitiesFilter) &&
      listing.validPurchaseQuantities.every(
        (q) => !quantitiesFilter.includes(q)
      )
    ) {
      return false;
    }
  } else {
    if (quantityFilter && quantity < quantityFilter) {
      return false;
    }
  }

  // filter by section
  const sectionIncluded =
    sectionIdFilters.length > 0 ? sectionIdFilters.includes(sectionId) : true;

  if (!sectionIncluded) {
    return false;
  }

  // No row filters for the section, return true
  if (
    sectionRowIdFilters[sectionId] == null ||
    sectionRowIdFilters[sectionId] === ROW_FILTER_MISSING
  ) {
    return true;
  }

  // filter by row
  const rowIncluded =
    rowIdFilters.length > 0 ? rowIdFilters.includes(rowId) : true;

  return rowIncluded;
};
